import script from "./UpsertWorkListFields.vue?vue&type=script&setup=true&lang=js"
export * from "./UpsertWorkListFields.vue?vue&type=script&setup=true&lang=js"

import "./UpsertWorkListFields.vue?vue&type=style&index=0&id=0ff18634&lang=css"

const __exports__ = script;

export default __exports__